import React, { FC } from 'react';
import { default as imageStyles } from './fitImageStyles';
import { ImageProps } from 'material-ui-image/lib/components/Image/Image';
import Image from 'material-ui-image';
import clsx from 'clsx';

export interface IFitImageProps extends ImageProps {
  scaleImage?: number;
  dataTest?: string;
}

const FitImage: FC<IFitImageProps> = ({ scaleImage, dataTest, ...props }) => {
  const styles = imageStyles({ scaleImage });

  return (
    <Image
      {...props}
      data-test={dataTest}
      src={props.src || '{missing-src}'}
      className={clsx(props.className, styles.image)}
    />
  );
};

export default FitImage;
